import { Provider } from '@angular/core';
import { of } from 'rxjs';
import { CurrentScopeFacade } from '../store/current-scope.facade';

function buildMockCurrentScopeFacadeDefaults(): Partial<CurrentScopeFacade> {
  return {
    brandSlug$: of(undefined),
    practiceSlug$: of(undefined),
    currentBrand$: of(undefined),
    currentPractice$: of(undefined),
    setBrandFromResolver: jest.fn(),
    setPracticeFromResolver: jest.fn(),
  };
}

export function MockCurrentScopeFacadeProvider(
  overrides: Partial<CurrentScopeFacade> = {}
): Provider {
  return {
    provide: CurrentScopeFacade,
    useValue: {
      ...buildMockCurrentScopeFacadeDefaults(),
      ...overrides,
    },
  };
}
